import {JbPageHeaderComponent} from "../../../core/component/jb-page-header.component";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {ResumeProcessItemEntity} from "../../../../../domain/entity/resume-process.item.entity";
import {useProcessRepository} from "../../../../../domain/repository/process.repository";
import {Button, Col, Descriptions, Divider, Form, Row, Select, Space, Table} from "antd";
import {AttendanceStatusComponent} from "../../attendance/component/attendance-status.component";
import {ProcessObjectTypeComponent} from "../../process/component/process-object-type.component";
import {StatusEnum} from "../../../../../domain/vo/status.enum";
import {FileExcelOutlined, SearchOutlined} from "@ant-design/icons";
import {FullAttendanceModal} from "../../attendance/component/full-attendance/modal";

export function ResumeProcessPage(props: any) {
  const [data, setData] = useState<ResumeProcessItemEntity[]>([])
  const [showAttendance, setShowAttendance] = useState<string>()
  const [filter, setFilter] = useState<any>();
  
  const processRepo = useProcessRepository();
  
  const numberFormat = useMemo(() => {
    return new Intl.NumberFormat('pr-BR', { style: 'currency', currency: 'BRL' }).format
  }, [])
  
  const loadData = useCallback(() => {
    processRepo.reportResumeProcess().then(res => setData(res.data))
  }, [])
  
  useEffect(() => {
    loadData()
  }, [loadData]);
  
  const revenueExpectation = useMemo(() => {
    return data.filter(w => w.processObjectType === 'revenue')
      .map(w => parseFloat(w.processObjectAmount))
      .reduce((prev, current) => prev + current, 0)
  }, [data])
  
  const costExpectation = useMemo(() => {
    return data.filter(w => w.processObjectType === 'cost')
      .map(w => parseFloat(w.processObjectAmount))
      .reduce((prev, current) => prev + current, 0)
  }, [data])
  
  const revenueResult = useMemo(() => {
    return data.filter(w => w.processObjectType === 'revenue')
      .map(w => w.processObjectResult ? parseFloat(w.processObjectResult) : 0)
      .reduce((prev, current) => prev + current, 0)
  }, [data])
  
  const deductionResult = useMemo(() => {
    return data.filter(w => w.processObjectType === 'cost')
      .map(w =>  w.processObjectResult ? parseFloat(w.processObjectResult) : 0)
      .reduce((prev, current) => prev + current, 0)
  }, [data])
  
  const filteredInfo = useMemo(() => {
    return data.filter(item => {
      if (!filter) return true;
      const { status, objectType } = filter;
      return (!status || item.attendanceStatus === status) &&  (!objectType || item.processObjectType === objectType)
    })
  }, [data,filter])
  
  return (
    <>
      <JbPageHeaderComponent
        title={'Relatório -> Resumo dos Processos'}
        description={'Resumo dos processos cadstrados no sistema'}
      />
      
      <Descriptions layout={'vertical'} column={4} bordered>
        <Descriptions.Item label={'Expectiativa Receita'}>
          {numberFormat(revenueExpectation)}
        </Descriptions.Item>
        <Descriptions.Item label={'Expectiativa Despesa'}>
          {numberFormat(costExpectation)}
        </Descriptions.Item>
        <Descriptions.Item label={'Total Despesa'}>
          {numberFormat(revenueResult)}
        </Descriptions.Item>
        <Descriptions.Item label={'Total Receita'}>
          {numberFormat(deductionResult)}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
      <Form layout={'horizontal'} onFinish={values => setFilter(values)}>
        <Row gutter={12}>
          <Col span={6}>
            <Form.Item label={'Status'} name={'status'}>
              <Select allowClear options={StatusEnum.list().map(item => ({
                label: StatusEnum.parse(item), value: item
              }))} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={'Tipo Objeto'} name={'objectType'}>
              <Select allowClear options={[
                { label: 'Receita', value: 'revenue' },
                { label: 'Despesa', value: 'deduction' },
              ]}/>
            </Form.Item>
          </Col>
          <Col>
            <Space>
              <Button htmlType={'submit'} icon={<SearchOutlined />}>Filtrar</Button>
              <Button onClick={() => processRepo.downloadReportResumeProcess()} icon={<FileExcelOutlined />}>Exportar</Button>
            </Space>
          </Col>
        </Row>
      </Form>
      <Table
        dataSource={filteredInfo}
        columns={[
          {
            title: 'Cód. Process',
            dataIndex: 'processCode',
            render: (code, row) => `${code} - ${row.processCourt}`
          },
          {
            title: 'Status',
            dataIndex: 'attendanceStatus',
            render: status => <AttendanceStatusComponent status={status} />
          },
          {
            title: 'Tipo Process',
            dataIndex: 'processTypeDescription',
            render: (type, row) => `${type} - ${row.processSubtypeDescription}`
          },
          {
            title: 'Cliente',
            dataIndex: 'clientName',
          },
          {
            title: 'Tipo Object',
            dataIndex: 'processObjectType',
            render: type => <ProcessObjectTypeComponent type={type} />
          },
          {
            title: 'Objeto',
            dataIndex: 'processObjectDescription',
          },
          {
            title: 'Expectativa',
            dataIndex: 'processObjectAmount',
            render: numberFormat,
          },
          {
            title: 'Resultado',
            dataIndex: 'processObjectResult',
            render: numberFormat
          },
        ]}
        rowClassName={'jb-table-row-clickable'}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              setShowAttendance(record.attendanceId)
            },
          };
        }}
      />
      {
        showAttendance && (
          <FullAttendanceModal attendanceId={showAttendance} onClose={() => {
            setShowAttendance(undefined)
            loadData()
          }} />
        )
      }
    </>
    
    
  )
}